import React, { useEffect, useState } from "react";
import './style.css';
interface CountdownTimerProps {
  timeInMilliseconds?: number; 
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ timeInMilliseconds }) => {
  const [timeLeft, setTimeLeft] = useState(timeInMilliseconds || 0);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1000) {
          clearInterval(timer); 
          return 0;
        }
        return prevTime - 1000;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (milliseconds: number) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${
      seconds < 10 ? `0${seconds}` : seconds
    }`;
  };

  return (
    <div className="next-draw">
      <h5 className="mb-1 text-nowrap">PRÓXIMO SORTEO</h5>
      <h1 className="countdown">{formatTime(timeLeft)}</h1>
    </div>
  );
};

export default CountdownTimer;
